import multiApiClient from "./base";

export const proxyApi = {
  // Get all proxy
  getProxies: () => multiApiClient.get("/proxy/"),

  // Create new proxy
  createProxy: (proxy) => multiApiClient.post("/proxy/", proxy),

  // Update proxy
  updateProxy: (id, proxy) => multiApiClient.put(`/proxy/${id}`, proxy),

  // Delete proxy
  deleteProxy: (id) => multiApiClient.delete(`/proxy/${id}`),

  //delete all proxy
  deleteAllProxies: () => multiApiClient.delete("/proxy/clear"),

  // get single proxy
  getProxy: (id) => multiApiClient.get(`/proxy/${id}`),

  // Toggle active status
  toggleProxyActiveStatus: (id) =>
    multiApiClient.post(`/proxy/${id}/toggle-active`),

  // Test proxy
  testProxy: (proxy) => multiApiClient.post("/proxy/test", proxy),
};
